/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeLocationForm } from '../../AttributeLocationForm'

export const AttributeLocationDialogUpdate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  location,
  actionUpdateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.locations.update.scenario')
    : currentProject
    ? t('attributes.locations.update.project')
    : t('attributes.locations.update.global')

  /**
   * Action received from the Location Form.
   * @see AttributeLocationForm
   *
   * @param {object} newLocation Location object to update.
   * @param {string} newLocationId Location Id to update.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newLocation, newLocationId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeLocationDialogUpdate.onDispatchAction()', {
      newLocation,
      newLocationId
    })

    dispatch(actionUpdateDispatch(newLocation, newLocationId, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'AttributeLocationDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).then()',
          {
            res
          }
        )
        if (res?.data?.isAxiosError) {
          enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
        } else if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(
          LoggerTypes.WARN,
          'AttributeLocationDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).catch()',
          { res }
        )

        checkErrorResponse(res, enqueueSnackbar, t)

        const _data = res?.response?.data || null
        if (_data && (_data?.fields || _data?.error)) {
          let _error = _data?.fields || {}
          if (_data?.error) {
            _error.generic = _data.error
          }
          setErrors(_error)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeLocationDialogUpdate.render()', {
    currentProject,
    currentScenario,
    location
  })

  return (
    <DialogFormEdit className="attribute-form location-dialog" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeLocationForm
        title={title}
        setOpenDialog={setOpenDialog}
        location={location}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeLocationDialogUpdate.displayName = 'AttributeLocationDialogUpdate'

AttributeLocationDialogUpdate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionUpdateDispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    orientation: PropTypes.number
  })
}

AttributeLocationDialogUpdate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionUpdateDispatch: null,
  location: {
    name: '',
    description: '',
    latitude: 0,
    longitude: 0,
    orientation: 0
  }
}
